import React from 'react';

// Utils
import withAuth from '../../../utils/hocs/withAuth';
import withSidebar from '../../../utils/hocs/withSidebar';
import SCOPE from '../../../utils/gate/scope';
import withPermission from '../../../utils/hocs/withPermission';
import productTypes from '../../../constants/productTypes';

// Components
import ProductLogistic from '../../../components/views/establishment/Products/Common/ProductLogistic/ProductLogistic';

function AccommodationLogistic() {
  return (
    <ProductLogistic productType={productTypes.accommodations} />
  );
}

export default withAuth(
  withPermission(
    withSidebar(AccommodationLogistic),
    {
      scopes: [SCOPE.update_ownEst_accommodation],
    },
  ),
);
